import { jsxs as l, jsx as n } from "react/jsx-runtime";
import { c as r } from "../../../index-2QXL0WYc.js";
import { capitalizeFirstLetter as g } from "../../../helpers/formatting/capitalizeFirstLetter.js";
import { GlobalCSSClass as m } from "../../../enums.js";
const v = "ids-validation-message-v5150", f = "ids-validation-message--prefix-v5150", x = "ids-validation-message--message-v5150", p = "ids-validation-message--danger-v5150", u = "ids-validation-message--warning-v5150", N = "ids-validation-message--success-v5150", w = "ids-validation-message--info-v5150", e = {
  validationMessage: v,
  prefix: f,
  message: x,
  danger: p,
  warning: u,
  success: N,
  info: w
}, M = ({
  prefix: s,
  status: a = "danger"
}) => s || `${a === "danger" ? "Error" : g(a)}: `, y = ({
  as: s = "div",
  children: a,
  className: o,
  prefix: t,
  status: i = "danger",
  visiblePrefix: d,
  ...c
}) => /* @__PURE__ */ l(
  s,
  {
    ...c,
    className: r(
      o,
      e.validationMessage,
      e[i],
      "iress-u-text",
      `iress--${i}`
    ),
    children: [
      /* @__PURE__ */ n(
        "div",
        {
          className: r(e.prefix, {
            [m.SROnly]: !d
          }),
          children: /* @__PURE__ */ n(M, { prefix: t, status: i })
        }
      ),
      /* @__PURE__ */ n("div", { className: e.message, children: a })
    ]
  }
);
export {
  y as ValidationBase
};
